module.exports = __webpack_public_path__ + "fonts/Inter-700-latin52.5eb4a77.woff2";